module.exports = __webpack_public_path__ + "05_bob_gray.81284fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_bob_gray.png
// module id = +u9l
// module chunks = 0